import React from "react";

const Education = () => {
  const isDarkMode = document.body.classList.contains("dark");

  return (
    <div
      className={`min-h-screen flex flex-col justify-start items-center p-8 ${
        isDarkMode ? "bg-[#111827] text-white" : "bg-white text-gray-900"
      }`}
      style={{ overflow: "hidden" }}
    >
      <div className="container mx-auto px-6 md:px-12">
        {/* Title */}
        <h1 className="text-5xl text-center font-bold mb-12">
          Education
        </h1>

        {/* Timeline Container */}
        <div className="relative flex flex-col items-center">
          {/* Vertical Line */}
          <div className="absolute border-l-4 border-blue-500 dark:border-blue-400 h-full left-1/2 transform -translate-x-1/2"></div>

          {/* First Education Block */}
<div className="relative mb-14 w-full max-w-md">
  <div className="absolute w-6 h-6 rounded-full bg-blue-500 left-1/2 transform -translate-x-1/2 -translate-y-3"></div>

  <div className="absolute bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold left-1/2 transform -translate-x-1/2 -translate-y-6">
    2017 – 2022
  </div>

  <div className="bg-white dark:bg-gray-800 shadow-xl p-8 rounded-lg mt-6">
    <h2 className="text-2xl font-semibold">
      Bachelor of Mechanical Engineering
    </h2>
    <p className="text-gray-600 dark:text-gray-400 mt-2">
      Engineering Degree with strong analytical and problem-solving skills.
    </p>
  </div>
</div>

{/* Second Education Block */}
<div className="relative mb-14 w-full max-w-md">
  <div className="absolute w-6 h-6 rounded-full bg-blue-500 left-1/2 transform -translate-x-1/2 -translate-y-3"></div>

  <div className="absolute bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold left-1/2 transform -translate-x-1/2 -translate-y-6">
    Front-End Diploma
  </div>

  <div className="bg-white dark:bg-gray-800 shadow-xl p-8 rounded-lg mt-6">
    <h2 className="text-2xl font-semibold">
      Front-End Development Diploma
    </h2>
    <p className="text-gray-600 dark:text-gray-400 mt-2">
      ITShare – Udemy – DEPI  
    </p>
    <p className="text-gray-600 dark:text-gray-400 mt-2">
      HTML, CSS, Sass, JavaScript, TypeScript, React, Next.js
    </p>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default Education;
